import "./PopupMessage.css";
interface PopupMessageProps {
  message: string;
  onClose: () => void;
}
const PopupMessage = ({ message, onClose }: PopupMessageProps) => {
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <p className="popup-text">{message}</p>
        <button className="popup-btn" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};
export default PopupMessage;
